import { Drawer } from "@mantine/core";
import React from "react";
import { queryClient } from "../../../App";
import TagAssigneeForm from "./TagAssigneeForm";
import TagAssignee from "../services/model/TagAssignee";

type TagAssigneeFormDrawerProps = {
  id: number;
  opened: boolean;
  onClose: () => void;
  assignee: TagAssignee[];
};

const TagAssigneeFormDrawer: React.FC<TagAssigneeFormDrawerProps> = ({
  id,
  opened,
  onClose,
  assignee,
}) => (
  <Drawer
    opened={opened}
    title="Add Employees"
    position="right"
    transition="slide-left"
    onClose={() => onClose()}
    size="xl"
    className="overflow-y-scroll"
  >
    <div style={{ padding: "25px", height: "80%", overflow: "auto" }}>
      <TagAssigneeForm
        id={id}
        assignee={assignee}
        onSuccess={() =>
          queryClient
            .invalidateQueries(["TagsDetailsApiService", id])
            .then(() => onClose())
        }
      />
    </div>
  </Drawer>
);

export default TagAssigneeFormDrawer;
